import { supabase } from '../lib/supabase';

export interface UserStats {
  searchesToday: number;
  leadsSavedTotal: number;
  whatsappVerifiedPercentage: number;
  leadsProspectedTotal: number; // Novo: Total de leads marcados como prospectados
  leadsWithWhatsappTotal: number; // Novo: Total de leads com status Validado ou Pendente
}

/**
 * Busca as estatísticas do usuário autenticado.
 */
export async function fetchUserStats(): Promise<UserStats> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    // Retorna zero stats se não houver usuário logado (embora o App.tsx bloqueie isso)
    return {
      searchesToday: 0,
      leadsSavedTotal: 0,
      whatsappVerifiedPercentage: 0,
      leadsProspectedTotal: 0,
      leadsWithWhatsappTotal: 0,
    };
  }

  // 1. Contagem total de leads salvos
  const { count: leadsCount, error: leadsError } = await supabase
    .from('leads')
    .select('id', { count: 'exact', head: true })
    .eq('user_id', user.id);

  if (leadsError) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error fetching leads count:', leadsError);
    }
    // Não lançamos erro, apenas usamos 0
  }

  // 2. Contagem de leads com status 'Validado'
  const { count: verifiedCount } = await supabase
    .from('leads')
    .select('id', { count: 'exact', head: true })
    .eq('user_id', user.id)
    .eq('whatsapp_status', 'Validado');

  // 3. Contagem de leads com status 'Pendente' ou 'Validado' (aqueles que têm WhatsApp)
  const { count: whatsappTotal } = await supabase
    .from('leads')
    .select('id', { count: 'exact', head: true })
    .eq('user_id', user.id)
    .or('whatsapp_status.eq.Validado,whatsapp_status.eq.Pendente');

  // 4. Contagem de leads prospectados
  const { count: prospectedCount } = await supabase
    .from('leads')
    .select('id', { count: 'exact', head: true })
    .eq('user_id', user.id)
    .eq('prospected', true);

  // 5. Calcular porcentagem de leads com WhatsApp Validado (em relação ao total de leads com WhatsApp)
  let whatsappVerifiedPercentage = 0;
  if (whatsappTotal && whatsappTotal > 0) {
    whatsappVerifiedPercentage = Math.round(((verifiedCount || 0) / whatsappTotal) * 100);
  }

  // 6. Contagem de buscas realizadas hoje (Simulação: Mantendo o mock)
  const searchesToday = 42;

  return {
    searchesToday: searchesToday,
    leadsSavedTotal: leadsCount || 0,
    whatsappVerifiedPercentage: whatsappVerifiedPercentage,
    leadsProspectedTotal: prospectedCount || 0,
    leadsWithWhatsappTotal: whatsappTotal || 0,
  };
}